// Author: Luis Booth - Febrero 2019
// Esto lo tuvo que haber hecho Cacaos 😡

import React, { Component, Fragment } from 'react';

class Loader extends Component {
  render() {

    return (
      <Fragment>
        <div className="loader" />
        <div className="loader-msg">
          <p>Book online and get $100 off</p>
        </div>
      </Fragment>
    );
  }
}

export default Loader;



// WEBPACK FOOTER //
// ./js/components/global/Loader.js